import { toDateOrDefault } from '../util/date';
import useQueryValue from './useQueryValue';

export default function useMonthPicker(): Date | null {
  return toDateOrDefault(useQueryValue('month', null), 'MM/yyyy');
}
